
import { Component } from 'vue-property-decorator';
import StackedForm from '../../../mixins/StackedForm';
import { mixins } from 'vue-class-component';
import { InputType } from '@/enums/InputType';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import { Article } from '@/interfaces/models/Article';
import { ExternalOrderProvider } from '@/enums/ExternalOrderProvider';

@Component({
  components: { VFormBuilder },
})
export default class DeliverooOptionsForm extends mixins(StackedForm) {
  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { getData: () => any; validate: () => Promise<boolean | boolean[]> };
  };

  get items() {
    return [
      {
        name: 'visible',
        type: InputType.Checkbox,
        default: true,
        label: 'article.form.visible',
      },
      {
        name: 'takeAwayPrice',
        type: InputType.Price,
        label: 'article.form.takeAwayPrice',
      },
      {
        name: 'deliveryPrice',
        type: InputType.Price,
        label: 'article.form.deliveryPrice',
      },
    ];
  }

  get internalInitialValues() {
    const deliverooProvider = (this.initialValues as Article | undefined)?.externalOrderProviderSettings?.find(
      (settings) => settings.provider === ExternalOrderProvider.DELIVEROO,
    );

    if (!deliverooProvider) {
      return null;
    }

    return deliverooProvider;
  }
}
